import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { plyxApi } from "@/lib/plyxApi";

const PlyxForgot = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handle = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await plyxApi.post("/plyx/auth/forgot", { email });
      setDone(true);
    } catch {
      // Even on error we show the same success state — anti-enumeration
      setDone(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-md">
        <h1 className="font-display text-4xl mb-2">Forgot password?</h1>
        <p className="text-white/60 mb-8">
          Pop your Plyx email below and we&apos;ll send a one-time reset link.
        </p>

        {done ? (
          <div className="p-5 rounded-md border border-white/15" data-testid="plyx-forgot-success" style={{ background: "linear-gradient(135deg, rgba(255,45,122,0.10) 0%, rgba(0,224,199,0.08) 100%)" }}>
            <div className="font-semibold text-lg mb-2">Check your inbox 💌</div>
            <p className="text-sm text-white/70 leading-relaxed">
              If an account exists for <strong className="text-white">{email}</strong>, you&apos;ll get an email with a reset link within a minute. The link is valid for 30 minutes.
            </p>
            <button
              type="button"
              onClick={() => navigate("/plyx/login")}
              data-testid="plyx-forgot-back-to-login"
              className="mt-5 text-sm font-semibold text-[#FF2D7A] hover:underline"
            >
              ← Back to login
            </button>
          </div>
        ) : (
          <form onSubmit={handle} className="space-y-4">
            <div>
              <label className="block text-xs uppercase tracking-wider text-white/60 mb-1.5">Email</label>
              <input
                type="email" autoComplete="email" required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="plyx-forgot-email"
                className="plyx-input w-full px-4 py-3 rounded-md bg-white/8 border border-white/15"
              />
            </div>
            <button
              type="submit" disabled={loading}
              data-testid="plyx-forgot-submit"
              className="w-full py-3 rounded-md text-[#0A0A0A] font-bold flex items-center justify-center gap-2 disabled:opacity-50"
              style={{ background: "linear-gradient(135deg, #FF2D7A 0%, #FFB42D 50%, #00E0C7 100%)" }}
            >
              {loading && <Loader2 className="w-4 h-4 animate-spin"/>}
              Send reset link
            </button>
            <div className="text-center text-sm text-white/50 pt-2">
              <Link to="/plyx/login" className="hover:text-white" data-testid="plyx-forgot-login-link">← Back to login</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default PlyxForgot;
